import React from 'react';
import i18next from 'i18next';

import { PageTitle } from '../PageTitle';
import { ChecklistUserService } from '../../services';

class ChecklistUserView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            checklistUserId: props.match.params.checklistUserId,
            errorMessage: null
        };
    }

    componentDidMount() {
        ChecklistUserService.get(this.state.checklistUserId).then((response) => {
            this.setState({checklistUser: response.checklistUser});
        }).catch((err) => {
            this.setState({errorMessage: i18next.t('messages.could-not-load-checklist-user')});
            console.error(err);
        })
    }

    render() {
        if (this.state.errorMessage) {
            return (
                <Redirect to={{
                  pathname: '/config/checklist/users',
                  state: {
                    errorMessage: this.state.errorMessage
                  }
                }}/>
            );
        } else if (!this.state.checklistUser) {
            return (
                <div className="loader">{i18next.t('loading')}</div>
            );
        } else {
            const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
            const searchValue = this.props.location.state && this.props.location.state.searchValue ? this.props.location.state.searchValue : null;
            return (
                <div>
                    <div className="row">
                    <PageTitle 
                        title={this.state.checklistUser.fullName}
                        editLinkWithParams={{
                            link: {
                                pathname: `/config/checklist/users/edit/${this.state.checklistUserId}`,
                                uiroute: '/config/checklist/users/edit/:checklistUserId',
                                state: {
                                    backLinkSearch: backLinkSearch,
                                    searchValue: searchValue
                                  }
                            }
                        }}
                        backLinkWithParams={{
                            link: {
                                pathname: '/config/checklist/users',
                                search: backLinkSearch,
                                state: {
                                    searchValue: searchValue
                            }
                            }
                        }}
                    />
                </div>
                <div className="op-content-box">
                    <div className="row">
                        <div className="col-sm-6 col-md-4 form-group">
                            <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-name">
                            <label>{i18next.t('form-labels.name')}</label><p>{this.state.checklistUser.fullName}</p>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4 form-group">
                        <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-group-child">
                        <label>{i18next.t('form-labels.assigned-locations')}</label>
                            {this.state.checklistUser.deviceGroupings.map(grouping => 
                                <p key={grouping.id}>{grouping.name}</p>)}
                        </div>
              </div>
                </div>
                </div>
            </div>);  
        }


    }
}

export default ChecklistUserView;